import _ from "lodash";
import { useQuery, useSubscription } from "@apollo/react-hooks";
import {
  MY_HR_GET_USER_BY_EMPLOYEE,
  MY_HR_USER_BY_EMPLOYEE_SUBSCRIPTION,
  MY_HR_USER_SUBSCRIPTION,
} from "my-hr/graphql";
import { useOcPolling } from "oc/hooks";

export const useMyHrUserByEmployee = ({
  employee,
}: {
  employee: string | null;
}) => {
  const { data, loading, error, refetch } = useQuery(
    MY_HR_GET_USER_BY_EMPLOYEE,
    {
      fetchPolicy: "cache-and-network",
      skip: !employee,
      pollInterval: useOcPolling(1000 * 60),
      variables: { employee },
    },
  );

  const { data: subsData } = useSubscription(
    MY_HR_USER_BY_EMPLOYEE_SUBSCRIPTION,
    {
      fetchPolicy: "network-only",
      skip: !employee,
      variables: { employee },
    },
  );

  useSubscription(MY_HR_USER_SUBSCRIPTION, {
    fetchPolicy: "network-only",
    skip: !employee,
    variables: { employee },
  });

  let resultData = subsData?.userByEmployee || data?.userByEmployee;
  let result = _.cloneDeep(resultData);

  if (result) {
    result.phone = result.phone === null ? "" : result.phone;
    result.validTo = result.validTo === null ? "" : result.validTo;
    result.ldapUser = result.ldapUser === null ? "" : result.ldapUser;
  }

  return { data: result, loading, error, refetch };
};

export default useMyHrUserByEmployee;
